// extracted by mini-css-extract-plugin
module.exports = {"meshbotDeleteWrapper":"MeshbotDelete_meshbotDeleteWrapper__1TQwU","disabled":"MeshbotDelete_disabled__1Kr28"};